import React from 'react';
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import validator from "validator";
import jsPDF from "jspdf";
import ReactToPrint from 'react-to-print';
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { facilityRegisterService, facilitySendOtp, statusChangeService, emailBaaDoc, facilityConfirmOtp, RegisterstatusChange } from "../../../services/facility/action";
import PdfPage from './pdf'
// import { facilityRegisterService, facilitySendOtp, facilityConfirmOtp,  } from "../../../services/facility/action";
import html2canvas from "html2canvas";
import toBlob from 'canvas-to-blob';
import moment from "moment";
import { NavLink } from "react-router-dom";
import DeleteModel from "../../common/Model/deleteModel";
import $ from 'jquery';
import {footer} from "../../../components/footerSize";
import { onlyAlphabets, onlyNumbers} from "../../common/keyValidation"

class FinalFacilityReg extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      approve: false,
      emailDoc: false,
      printDoc: false,
      confirmPin: false,
      confirmOtpButton: false,
      otp: "",
      email: "",
      mobile: "",
      name: "",
      confirmPopUp:false,
      userType : "",
    }
  }

  handleChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
   
    this.setState({ [name]: value },()=>{
      if(this.state.otp.length == 6){
        this.refs.otpRef.focus();
     }
    });
  };

 


  requestOtp = (e) => {
    e.preventDefault();
    this.setState({
      emailDoc: false
    })

    let data = this.props.saveRegisteredData
    let email = data.email;
    let mobile = data.mobile;

    let payLoad = {
      email,
      mobile,
     }




    this.props.facilitySendOtp(payLoad);


  }
  confirmOtp = (e) => {
    e.preventDefault();
    this.setState({
      emailDoc: false
    })
    let data = this.props.saveRegisteredData
    let emailId = data.email;
    let mobile = data.mobile;
    let otp = this.state.otp; 

    let payLoad = {
      emailId,
      mobile,
      otp
    }

    this.props.facilityConfirmOtp(payLoad)

  }


  approveRegister = (e) => {
     this.setState({
      approve: true
    })
  }

  componentDidMount(){
     // onDocumentReady function bind
     $(document).ready(function () {
      footer("#content");
  });

  // onResize bind of the function
  $(window).resize(function () {
      footer("#content");
  });
  this.props.statusChangeService();

    if(this.props.saveRegisteredData){
    let data= this.props.saveRegisteredData 

    let facilityName = data.facilityName;
    let firstName = data.firstName 
    let lastName= data.lastName;
    let email = data.email;
    let name =  data.firstName + " " + data.lastName;
    let userType = data.userType;
    this.setState({
        facilityName,
        email,
        firstName,
        lastName,
        name,
        userType
    })
}
}



  emailDocument = ()=> {

 

    const {facilityName, firstName, lastName, email } = this.state

 
       let  payloadOne = {
        "facilityName":facilityName,
        "firstName": firstName,
        "lastName": lastName,
        "email":email
        }
        
        let date = moment().format("MMM Do YYYY"); 


    let dataTwo ={
          "facilityName": facilityName,
        "doctorName": firstName + " " + lastName,
        "registerPersonName":firstName + " " + lastName,
        "todayDate":date
        }

        
        
        const formData = new FormData();
       formData.append('userDetails', JSON.stringify(payloadOne))
       formData.append('inputField', JSON.stringify(dataTwo))


        this.props.emailBaaDoc(formData);


    


    }





  componentWillReceiveProps = nextProps => {

    if (nextProps) {

       

      if (nextProps.confirmOtpStatus) {
        this.setState({
          confirmPin: true
        })
       
      }
      if (nextProps.sendOtpStatus) {
        this.setState({
          confirmOtpButton: true
        })
     
      }


    } else {
      toast.error(nextProps.message);
    }


  };

  printDocument = () => {
  
    window.print();
 
} 

closeUp = () =>{
  this.setState({
    confirmPopUp : false
  })
}
 
 
 
confirmOkay = () =>{
    this.setState({
        confirmPopUp:false
    },()=>{
        
      this.approveRegister();
      
    })
 
   // this.props.history.push("/login");
}

 

  render() {
   
    let date = moment().format("MMM Do YYYY");

    const {
      confirmOtpButton,
      printDoc,
      emailDoc,
      confirmPin,
      otp,
      firstName,
      approve,
      name,
      userType
    } = this.state;


    return (
      <>

      <div className="registration-wrapper">

      <Header routes={[{"name" : "Registration", "route" : "/Register",},{"name" : "Facility Registration", "route" : "/FacilityReg" }]} />

        {/* <!-- Content Section --> */}
        <div className="register-content">
          <div className="container">
            <div className="form-head mt-3">
              <h1>Practice/Doctor Registration</h1>
              <label className="head-sub-title">If you are Registering as Practice, then you can add individual Doctors from your dashboard</label>
            </div>
 
            <div className="form-body">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="default-section">
                    <div className="default-date">
                      <label>BUSINESS ASSOCIATES AGREEMENT:</label>
                    </div>
                  </div>
                  <div className="iframe-section">
                  <div className="pdf-size" id ="pdf-toPrint">
                  <PdfPage   ref={el => (this.componentRef = el)} approve={approve}  status={confirmPin} /></div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 otp-section-2">
                  <div className="bor-btm">
                    <div className="default-date">
                      <label><i className="fa fa-calendar" aria-hidden="true"></i>{date}</label>
                    </div>
                    <div className="default-name">
                      <label><i className="fa fa-user" aria-hidden="true"></i>{name}</label>
                    </div></div>
                  <div className="otp-box">
                  {!confirmPin &&
                    <>
                    {!confirmOtpButton &&
                    <>
                    <label>To Confirm your signature we need to send the OTP to Your Mobile and Mail</label>
                    <div className="request-otp-btn">
                      <button onClick={this.requestOtp} className="btn">Request OTP</button>
                    </div>

                    </>
                    }

                     {confirmOtpButton &&
                     <>
                    <label>Enter the OTP Below</label>
                    <input type="text" className="otp-input" maxlength='6'autocomplete="off" value={otp} onChange={this.handleChange} onKeyPress={onlyNumbers} name="otp" autoFocus />
                    <div className="request-otp-btn">
                      <button onClick={this.confirmOtp} ref="otpRef" className="btn">Confirm OTP</button>
                    </div>
                    </>
                     }

                    </>
                  }

                  {confirmPin &&
                      <>
                       <img src="images/successicon.png" className="otp-image"/>
                    <label className="success-otp">You have Successfully signed in BAA Document. Now you are ready to click on Accept button to Register</label>
                    
                    </>
                      }

                  </div>
                  <div className="otp-button">
           
                   <NavLink to="/FacilityReg" >
                    <button type="button" className="back-btn">Back</button>
                    </NavLink>
                    <button type="button" onClick={()=>{this.setState({confirmPopUp:true})}} disabled={!confirmPin} className="accept-btn">Accept</button>
                  </div>
                  <div className="sent-option-btn">
                    <button type="button" disabled={!confirmPin} className="otp-email"  onClick={this.emailDocument} title="Email Signed Document"><i className="fa fa-envelope" aria-hidden="true"></i> Email Signed Document</button>
                    <button type="button" disabled={!confirmPin} className="otp-print" onClick={this.printDocument} title="Print Signed Document"><i className="fa fa-print" aria-hidden="true"></i> Print Signed Document</button>
                  </div>
                </div>
              </div>
            </div>
          </div>     
        </div>
              
        {/* <!-- Footer Section --> */}
        <Footer />
      </div>
      <DeleteModel page="facilityReg" header="Thank you for registering with ePaper Road" text="We look forward to freeing you from the burden of 
             reproducing medical records. A representative will be in contact within 24 hours to complete your set up." 
              status={this.state.confirmPopUp} closePop={this.closeUp}  confirmOkay={this.confirmOkay} />
    </>
    )
  }
}

const mapStateToProps = state => ({

  facilityRegisterDetails: state.facilityReducer.facilityRegisterDetails,
  facilityRegisterStatus: state.facilityReducer.facilityRegisterStatus,

  // message: state.commonReducer.message,
  sendBaaDocStatus: state.facilityReducer.sendBaaDocStatus,
  saveRegisteredData: state.facilityReducer.saveRegisteredData,
  sendOtpStatus: state.facilityReducer.sendOtpStatus,
  confirmOtpStatus: state.facilityReducer.confirmOtpStatus,
  saveRegDataStatus: state.facilityReducer.saveRegDataStatus

});

const mapDispatchToProps = dispatch => ({
  facilitySendOtp: payLoad => dispatch(facilitySendOtp(payLoad)),
  facilityConfirmOtp: payLoad => dispatch(facilityConfirmOtp(payLoad)),
  RegisterstatusChange: () => dispatch(RegisterstatusChange()),
  statusChangeService: () => dispatch(statusChangeService()),
  facilityRegisterService : payLoad => dispatch(facilityRegisterService(payLoad)),
  emailBaaDoc: formData => dispatch(emailBaaDoc(formData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FinalFacilityReg));